/* eslint-disable react-hooks/exhaustive-deps */
import { useFormikContext } from "formik";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { listarFrecuenciasMonitoreo } from "../api/General";
import { useCatalog } from "../context/Catalog";
import { useTramite } from "../context/Tramite";
import "./css/components.css";
import { isInvalid } from "../utils/forms";
import { isEditable } from "../utils/tramite";
import { crearMonitoreoAire } from "../utils/data";
import Loader from "./controls/Loader";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import QuestionField from "./controls/QuestionField";
import TextField from "./controls/TextField";
import ObjectField from "./controls/ObjectField";
import SelectField from "./controls/SelectField";
import TextareaField from "./controls/TextareaField";

export default function EmisionesGaseosasForm({ ...props }) {
  const { tramite } = useTramite();
  const tramiteForm = useFormikContext();
  const { t } = useTranslation();
  const frecuenciasCatalog = useCatalog(
    ["frecuenciasMonitoreo"],
    () => listarFrecuenciasMonitoreo({}),
  );
  const loading = frecuenciasCatalog.loading;
  const handleConRegistroEmisionesGaseosasChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleRegistroEmisionesGaseosasChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleConMonitoreoAireChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleMonitoreoAireChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleConEmisionesComponentesNaturales = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleConEmisionesCombustionHidrocarburos = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleConEmisionesOtrosGases = (event) => {
    tramiteForm.handleChange(event);
  };
  useEffect(() => {
    if (tramiteForm.values.conMonitoreoAire) {
      tramiteForm.setFieldValue(
        "monitoreoAire",
        tramiteForm.values.monitoreoAire || crearMonitoreoAire(),
        false,
      );
    } else {
      tramiteForm.setFieldValue("monitoreoAire", undefined, false);
    }
  }, [tramiteForm.values.conMonitoreoAire]);
  return (
    <Loader loading={loading}>
      <Grid>
        <Row>
          <Col lg={12}>
            <QuestionField
              id="conRegistroEmisionesGaseosas"
              name="conRegistroEmisionesGaseosas"
              label={t(
                `tramite.conRegistroEmisionesGaseosas.${tramiteForm.values?.domicilio?.provincia?.codigo}`,
              )}
              value={tramiteForm.values?.conRegistroEmisionesGaseosas}
              onChange={handleConRegistroEmisionesGaseosasChange}
              isInvalid={isInvalid("conRegistroEmisionesGaseosas", tramiteForm)}
              error={t(tramiteForm.errors.conRegistroEmisionesGaseosas)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={4}>
            <TextField
              id="registroEmisionesGaseosas"
              name="registroEmisionesGaseosas"
              label={t("tramite.registroEmisionesGaseosas")}
              value={tramiteForm.values?.registroEmisionesGaseosas}
              onChange={handleRegistroEmisionesGaseosasChange}
              maxLength={20}
              isInvalid={isInvalid("registroEmisionesGaseosas", tramiteForm)}
              error={t(tramiteForm.errors.registroEmisionesGaseosas)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <QuestionField
              id="conMonitoreoAire"
              name="conMonitoreoAire"
              label={t("tramite.conMonitoreoAire")}
              value={tramiteForm.values?.conMonitoreoAire}
              onChange={handleConMonitoreoAireChange}
              isInvalid={isInvalid("conMonitoreoAire", tramiteForm)}
              error={t(tramiteForm.errors.conMonitoreoAire)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <label>{t("tramite.monitoreoAire")}</label>
            <ObjectField
              id="monitoreoAire"
              name="monitoreoAire"
              value={tramiteForm.values?.monitoreoAire}
              onChange={handleMonitoreoAireChange}
              disabled={!isEditable(tramite)}
            >
              {({ value, setProperty, disabled }) => (
                <Grid>
                  <Row>
                    <Col>
                      <SelectField
                        id="monitoreoAire_frecuencia"
                        name="monitoreoAire.frecuencia"
                        label={t("monitoreoAire.frecuencia")}
                        value={value?.frecuencia}
                        onChange={(event) => {
                          event.preventDefault();
                          setProperty("frecuencia", event.target.value);
                        }}
                        options={frecuenciasCatalog.data}
                        labelAttr="nombre"
                        valueAttr="codigo"
                        emptyLabel="..."
                        isInvalid={isInvalid(
                          "monitoreoAire.frecuencia",
                          tramiteForm,
                        )}
                        error={t(tramiteForm.errors.monitoreoAire?.frecuencia)}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <TextareaField
                        id="monitoreoAire_descripcion"
                        name="monitoreoAire.descripcion"
                        label={t("monitoreoAire.descripcion")}
                        value={value?.descripcion}
                        onChange={(event) => {
                          event.preventDefault();
                          setProperty("descripcion", event.target.value);
                        }}
                        maxLength={1024}
                        rows={12}
                        isInvalid={isInvalid(
                          "monitoreoAire.descripcion",
                          tramiteForm,
                        )}
                        error={t(tramiteForm.errors.monitoreoAire?.descripcion)}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                </Grid>
              )}
            </ObjectField>
          </Col>
        </Row>
        <Row>
          <Col>
            <QuestionField
              id="conEmisionesComponentesNaturales"
              name="conEmisionesComponentesNaturales"
              label={t("tramite.conEmisionesComponentesNaturales")}
              value={tramiteForm.values.conEmisionesComponentesNaturales}
              onChange={handleConEmisionesComponentesNaturales}
              isInvalid={isInvalid(
                "conEmisionesComponentesNaturales",
                tramiteForm,
              )}
              errors={tramiteForm.errors.conEmisionesComponentesNaturales}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <QuestionField
              id="conEmisionesCombustionHidrocarburos"
              name="conEmisionesCombustionHidrocarburos"
              label={t("tramite.conEmisionesCombustionHidrocarburos")}
              value={tramiteForm.values.conEmisionesCombustionHidrocarburos}
              onChange={handleConEmisionesCombustionHidrocarburos}
              isInvalid={isInvalid(
                "conEmisionesCombustionHidrocarburos",
                tramiteForm,
              )}
              errors={tramiteForm.errors.conEmisionesCombustionHidrocarburos}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <QuestionField
              id="conEmisionesOtrosGases"
              name="conEmisionesOtrosGases"
              label={t("tramite.conEmisionesOtrosGases")}
              value={tramiteForm.values.conEmisionesOtrosGases}
              onChange={handleConEmisionesOtrosGases}
              isInvalid={isInvalid("conEmisionesOtrosGases", tramiteForm)}
              errors={tramiteForm.errors.conEmisionesOtrosGases}
            />
          </Col>
        </Row>
      </Grid>
    </Loader>
  );
}
